import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';
import lineas from '../modules/Lineas';
import tallas from '../modules/tallas';
import colores from '../modules/colores';
import categorias from '../modules/categorias';
import generos from '../modules/generos';
import niveles from '../modules/niveles';
import targets from '../modules/targets';
import grupos from '../modules/grupos';
import caracteristicas from '../modules/caracteristicas'
import tipodedocumentos from '../modules/tipodedocumentos'
import transportistas from '../modules/transportistas'
import productos from '../modules/productos'
import clientes from '../modules/clientes'
import descuentos from '../modules/descuentos'
import referencias from '../modules/referencias'
import marcas from '../modules/marcas'
import pedidos from '../modules/pedidos'
import Informes from '../modules/Informes'

Vue.use(Vuex, axios);

export default new Vuex.Store({
  state: {
    login: false,
    user: '',
    usuario: '',
    password: '',
    numero: '',
    apis: [],
    id: '',
    descripcion: '',
    elemento: '',
    value0: null,
    eliminar: '',
    eliminer: '',
    // descripcionmodal: '',
    idmodal: '',
    banderamodal: true,
    bandedacara: true,
    idcolor: '',
    nombrecolor: '',
    logincorrecto: true,
    alerta: '',
    //variables Productos

    codigoproducto: '',
    costoproducto: '',
    disponibleproducto: '',
    foto: '',

    descripcion2: '',
    transportistas: '',
    tipodedocumento: '',
    targets: '',
    tallas: '',
    niveles: '',
    lineas: '',
    grupos: '',
    generos: '',
    colores: '',
    categorias: '',
    caracteristicas: ''
  },
  actions: {
  },
  mutations: {

    //transportistas
    //tipodedocumento
    //targets
    //tallas
    //niveles
    //lineas
    //grupo
    //generos
    //colores
    //caterogorias
    //caracteristicas

    // datos productos

    cargardatoslineas(state) {
      const token = state.numero;

      state.lineas = ''
      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Lineas", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.lineas = response.data.data;



        });

    },


    cargardatosglobal(state) {

      state.lineas = ''
      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Lineas", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.lineas = response.data.data;



        });

      const token = state.numero;
      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Transportista", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          //datos transportistas
          state.transportistas = response.data.data;


        });
      //tipodedocumento
      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/tiposdocumentos", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.tipodedocumento = response.data.data;


        });
      //targets
      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/targets", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.targets = response.data.data;


        });
      //tallas
      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/tallas", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.tallas = response.data.data;


        });

      //niveles

      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/niveles", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.niveles = response.data.data;


        });

      //lineas

      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Lineas", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.lineas = response.data.data;



        });
      //grupos
      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/grupos", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.grupos = response.data.data;


        });
      //generos
      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/generos", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {

          state.generos = response.data.data;


        });
      //colores
      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/colores", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.colores = response.data.data;


        });
      //categorias
      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/categorias", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.categorias = response.data.data;



        });
      //caracteristicas
      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Caracteristicas", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.caracteristicas = response.data.data;


        });




    },



    validar(state, api) {
      state.descripcion2 = api.nombrelinea;
    },
    SET_APIS(state, apis) {
      state.apis = apis;

    },
    agregar(state, num) {
      state.numero = num;

    },


    login(state, datoss) {
      state.user = datoss.login;
      axios
        .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Token", datoss)
        .then((response) => {
          let tokenn = response.data.token;
          let user = response.data.idusuario
          //this.respuesta = <
          state.numero = tokenn;
          state.user = user

          state.logincorrecto = false


        })
        .catch((e) => {
          console.log(e);
          state.alerta = true

        });
    },
    alertadato(state) {
      state.alerta = false
    },

    value0(state, cambio) {
      state.banderamodal = cambio
    },

    value1(state, cambio) {
      state.banderamodal = cambio

    },
    cambiar(state, num) {
      state.numero = num;
      if (num) {
        this.state.numero = !null
      }
    },

    /* // ESTE ES EL RELOAD DE LA PAGINA               */
    recargarlineas() {
      const token = this.numero;
      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Lineas", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          this.apis = response.data.data;

          this.aux2 = this.apis;
        });


    },

  },
  modules: {
    lineas,
    tallas,
    colores,
    categorias,
    generos,
    niveles,
    targets,
    grupos,
    caracteristicas,
    clientes,
    tipodedocumentos,
    transportistas,
    productos,
    descuentos,
    referencias,
    marcas,
    pedidos,
    Informes
  }
});
